import React from 'react';
import { LinkButton } from '@adsk/alloy-react-button';
import Panel from '@adsk/alloy-react-panel';
import theme from '@adsk/alloy-react-theme';
import i18n from '../../helpers/i18n';
import { SideFiltersType } from '../../hooks/useFilters';
import { Filters } from './Filters';

export type FiltersPanelProps = {
  isOpen: boolean;
  toggleIsOpen: () => void;
  filters: SideFiltersType;
  filtersCount: number;
  onFilterChange: (filterKey: string, value?: string) => void;
  clearFilters: () => void;
};

export const FiltersPanel = ({
  isOpen,
  toggleIsOpen,
  filters,
  filtersCount,
  onFilterChange,
  clearFilters,
}: FiltersPanelProps) => {
  return (
    <Panel
      style={{
        height: 'auto',
        boxShadow: `${theme.colors.charcoal200} -1px -1px 0px 0px`,
      }}
      open={isOpen}
      renderHeader={() => (
        <Panel.Header
          title={<span>{i18n.t('FILTERS')}</span>}
          renderActions={() =>
            filtersCount ? (
              <LinkButton onClick={clearFilters} style={{ margin: '0 10px' }}>
                <span>{i18n.t('CLEAR_FILTERS')}</span>
              </LinkButton>
            ) : null
          }
          onClose={() => toggleIsOpen()}
        />
      )}
    >
      <Panel.Body id="FiltersPanel__body">
        <Filters filters={filters} onFilterChange={onFilterChange} />
      </Panel.Body>
    </Panel>
  );
};
